import { useEffect } from "react";

import { Navigate, Route, Routes, useLocation, useParams } from "react-router-dom";

import { locales } from "../docs.config.js";
import { defaultRoute, isSectionEnabled, sectionConfig } from "./lib/content.js";
import { isLocale, LocaleProvider } from "./lib/i18n.jsx";
import ApiPage from "./routes/ApiPage.jsx";
import GuidePage from "./routes/GuidePage.jsx";

// Sobe ao topo em toda troca de página, mas não quando a URL só ganhou uma
// âncora — aí o salto já é o comportamento desejado e subir seria o oposto.
function ScrollReset() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
}

// Uma seção pode ser guias, referência da API ou página avulsa. O tipo está em
// docs.config.js, então adicionar uma seção não passa por este arquivo.
function SectionRoute() {
  const { locale, section } = useParams();

  if (!isLocale(locale)) return <Navigate to={defaultRoute(locales.default)} replace />;

  // Seção inexistente ou com `enabled: false`: um link antigo não pode abrir
  // uma tela que foi tirada do ar. `hidden: true` passa por aqui de propósito.
  const config = sectionConfig(section);
  if (!section || !config || !isSectionEnabled(section)) return <Navigate to={defaultRoute(locale)} replace />;

  return <LocaleProvider locale={locale}>{config.type === "openapi" ? <ApiPage /> : <GuidePage />}</LocaleProvider>;
}

function LocaleRoot() {
  const { locale } = useParams();
  const target = isLocale(locale) ? locale : locales.default;
  return <Navigate to={defaultRoute(target)} replace />;
}

export default function App() {
  return (
    <>
      <ScrollReset />
      <Routes>
        <Route path="/" element={<Navigate to={defaultRoute()} replace />} />
        <Route path="/:locale" element={<LocaleRoot />} />
        <Route path="/:locale/:section" element={<SectionRoute />} />
        <Route path="/:locale/:section/:slug" element={<SectionRoute />} />
        <Route path="*" element={<Navigate to={defaultRoute()} replace />} />
      </Routes>
    </>
  );
}
